/**
 * Hover cards are positioned against their logo or keyword, so one opened near the
 * right edge of a wide row hangs off the screen and drags a horizontal scrollbar in
 * with it. Nudge the card back inside the viewport each time it opens; the offset is
 * recomputed from scratch, because the same card lands in a different place at every
 * window width.
 */
export function keepOnScreen(card: HTMLElement) {
  const host = card.parentElement;
  if (!host) return;
  const place = () =>
    requestAnimationFrame(() => {
      card.style.marginLeft = '';
      const r = card.getBoundingClientRect();
      if (!r.width) return;
      const gutter = 8;
      const edge = document.documentElement.clientWidth - gutter;
      const shift = r.right > edge ? edge - r.right : r.left < gutter ? gutter - r.left : 0;
      if (shift) card.style.marginLeft = `${shift}px`;
    });
  host.addEventListener('mouseenter', place);
  host.addEventListener('focusin', place);
  return {
    destroy() {
      host.removeEventListener('mouseenter', place);
      host.removeEventListener('focusin', place);
    },
  };
}
